import moment from 'moment';
import { dateFormat } from '../../../constants';
import { getStopApi } from '../../../services/StopApi/StopApi';

export const getCompletionList = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    return response;
  })
}

export const getAuthorizationList = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    const json = response.data;
    return {
      isLoading: false,
      total: response?.totalRows,
      data: json?.map((item, index) => ({
        ...item,
        id: index,
        flag: item.flag ? item.flag : '',
        authId: item.authId ? item.authId : '',
        start: item.start
          ? moment(item.start).format(dateFormat).split('T')[0]
          : '',
        end: item.end ? moment(item.end).format(dateFormat).split('T')[0] : '',
        admit: item.admit
          ? moment(item.admit).format(dateFormat).split('T')[0]
          : null,
        authDischargeType: item.authDischargeType
          ? item.authDischargeType
          : '',
        discharge: item.discharge
          ? moment(item.discharge).format(dateFormat).split('T')[0]
          : '',
        adminXferAdm: item.adminXferAdm ? item.adminXferAdm : '',
        authType: item.authType ? item.authType : '',
        CBPID: item.CBPID ? item.CBPID : '',
        maxUnits: item.maxUnits ? item.maxUnits : '',
        maxUnitsPerWeek: item.maxUnitsPerWeek ? item.maxUnitsPerWeek : '',
        epdID: item.episode?.epdID ? item.episode?.epdID : '',
        CDC: item.episode?.CDC ? item.episode?.CDC : '',
        reg: item.episode?.reg ? item.episode?.reg : '',
        CCCMS: item.episode?.CCCMS,
        referralSource: item.episode?.referralSource?.value
          ? item.episode?.referralSource?.value
          : '',
        prtID: item.episode?.partcipant.prtID
          ? item.episode?.partcipant?.prtID
          : '',
        paticipantKey: item.episode?.partcipant.paticipantKey
          ? item.episode?.partcipant.paticipantKey
          : '',
        gnd: item.episode?.partcipant.gnd.value
          ? item.episode?.partcipant.gnd.value
          : '',
        registratnt290: item.episode?.partcipant.registratnt290,
        MOD: item.cbp?.MOD ? item.cbp.MOD : '',
        CBPName: item.cbp?.CBPName ? item.cbp.CBPName : '',
        sb1453Eligible: item.episode?.sb1453Eligible,
        fundingSap: item.fundingSap ? item.fundingSap.value : '',
      })),
    };
  }).catch((e) => console.log(e));
};
